import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template14.css";
import "./CheckoutTemplate14.css";

/*
   Checkout Template 14 — a seamless continuation of sales Template 14
   ("Deep Ocean", premium dark navy + luminous cyan glow). Reuses Template14.css
   directly (the .clp14-root design system): the real .do14-nav, the deep-ocean
   .do14-hero with its drifting glows + .do14-title/.do14-grad gradient accent,
   the glowing .do14-btn.do14-btn-p button and the .do14-foot footer. Only the
   form + order-summary glass cards are checkout-specific (CheckoutTemplate14.css),
   styled to match the template's dark glass panels.
*/
export default function ThankYouTemplate14({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp14-root">
      {/* Deep-ocean glow backdrop — same as the sales page */}
      <div className="do14-deep" aria-hidden="true">
        <span className="do14-glow do14-g1" />
        <span className="do14-glow do14-g2" />
        <span className="do14-glow do14-g3" />
        <span className="do14-glow do14-g4" />
        <span className="do14-grain" />
      </div>

      {/* NAV — same as the sales page */}
      <nav className="do14-nav scr">
        <div className="do14-wrap do14-nav-in">
          <a href="#top" className="do14-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok14-brandtext">{c.brand}</span>}
          </a>
          <span className="cok14-secure">✓ Order confirmed</span>
        </div>
      </nav>

      {/* HERO — reuses the sales deep-ocean hero band + gradient accent title */}
      <header className="do14-hero cok14-hero" id="top">
        <div className="do14-wrap cok14-hero-in">
          <span className="cok14-eyebrow">Thank you</span>
          <h1 className="do14-title">
            You're <span className="do14-grad">enrolled</span>
          </h1>
          {c.sub ? <p className="do14-sub cok14-sub">{c.sub}</p> : null}
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's dark glass card style */}
      <div className="do14-wrap">
        <ThankYouBody data={data} p="cok14" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="do14-foot">
        <div className="do14-wrap do14-foot-in">
          <div className="cok14-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
